









































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import SingleCoup from './singleCoup.vue'
import BagPop from './bagPop.vue'
import * as Types from '../../mini'
import { getPublicParams, convertPxToVw } from '../../utils'

@Component({
  components: {
    SingleCoup,
    BagPop,
  },
})
export default class Coupon extends Vue {
  @Prop() data: Types.CouponComp
  @Prop() uploadEvent: any
  @Prop() pageId: number
  publicParams: any = {}
  singleCoupInfos: any = []
  bagCoupInfos: any = []
  showBagPop: boolean = false
  bagFail: boolean = false
  bagFailList: number[] = []

  get pageIdBk() {
    return this.pageId || this.$route.query.page_id || ''
  }

  get singleCoupInfosFilter() {
    let filterList = this.singleCoupInfos
    if (!this.data.coupSingle.showEnded) {
      filterList = filterList.filter(
        el => !(this.isEnd(el) || this.isExpire(el))
      )
    }
    if (!this.data.coupSingle.showRobbed) {
      filterList = filterList.filter(el => !this.isEmpty(el))
    }
    return filterList
  }

  get realMargin() {
    return convertPxToVw(this.data.coupBag.compMargin)
  }

  get isEnd() {
    return el => {
      let isReceive = !!el.use_end_time
      let isEnd = !!el.is_end
      let isOverTime1 =
        el.end_time && this.toTimeStamp(el.end_time) < +new Date()
      let isOverTime2 =
        el.used_end_time && this.toTimeStamp(el.used_end_time) < +new Date()
      return !isReceive && (isEnd || isOverTime1 || isOverTime2)
    }
  }

  get isExpire() {
    return el => {
      let isUsed = !!el.used
      let isOverTime =
        el.use_end_time && this.toTimeStamp(el.use_end_time) < +new Date()
      return !isUsed && isOverTime
    }
  }

  get isEmpty() {
    return el => {
      let isReceive = !!el.use_end_time
      let isNoStock = el.limit_count <= el.obtained_count
      return !isReceive && isNoStock
    }
  }

  get bagReceiveStatus() {
    if (this.bagFail) {
      return {
        status: 'fail',
        text: '领取失败',
      }
    }
    if (this.bagCoupInfos.some(el => el && el.use_end_time)) {
      return {
        status: 'hasReceive',
        text: '查看优惠券',
      }
    } else {
      return {
        status: 'canRec',
        text: '立即领取',
      }
    }
  }

  async created() {
    await this.initData()
  }

  async initData() {
    this.publicParams = await getPublicParams(env)
    if (this.data.showType === 'single') {
      let { data: coupInfos } = await this.$axios.post(
        '/api/goods/shop/market/microPage/getCouponList',
        {
          coupon_ids: this.data.coupSingle.coupIds,
          ...this.publicParams,
        }
      )
      this.singleCoupInfos = coupInfos.sort((a, b) => {
        return (
          this.data.coupSingle.coupIds.indexOf(a.coupon_id) -
          this.data.coupSingle.coupIds.indexOf(b.coupon_id)
        )
      })
    } else {
      let { data: coupInfos } = await this.$axios.post(
        '/api/goods/shop/market/microPage/getCouponList',
        {
          coupon_ids: this.data.coupBag.coupIds,
          ...this.publicParams,
        }
      )
      this.bagCoupInfos = coupInfos.sort((a, b) => {
        return (
          this.data.coupBag.coupIds.indexOf(a.coupon_id) -
          this.data.coupBag.coupIds.indexOf(b.coupon_id)
        )
      })
    }
  }

  // 券包领取
  async receiveBag() {
    if (this.bagFail) return
    await env.init()
    if (!(await env.getIsLogin())) {
      return await env.login()
    }
    this.clickEvent()
    if (!this.data.coupBag.coupIds.length) {
      this.$Toast('还没有可以领取的优惠券~')
      this.bagFail = true
      return
    }
    if (this.bagReceiveStatus.status === 'hasReceive') {
      return (this.showBagPop = true)
    }
    let recRes: any
    try {
      const { data: data } = await this.$axios.post(
        '/api/goods/shop/market/microPage/acquireCoupon',
        {
          page_id: this.pageIdBk,
          coupon_ids: this.data.coupBag.coupIds,
          ...this.publicParams,
        }
      )
      recRes = data
    } catch (e) {
      this.bagFail = true
      recRes = e
    }
    if (!this.bagFail) {
      await this.initData()
      this.$nextTick(() => {
        let toast
        if (
          recRes.message &&
          recRes.message.not_receive &&
          recRes.message.not_receive.length > 0
        ) {
          if (
            recRes.message.not_receive.length ===
            this.data.coupBag.coupIds.length
          ) {
            this.bagFail = true
          }
          toast = `${recRes.message.received.length}张领取成功，${recRes.message.not_receive.length}张领取失败`
          this.bagFailList = recRes.message.not_receive.map(el => el.id)
        } else {
          toast = '领取成功'
        }
        this.$Toast(toast)
        this.showBagPop = true
      })
    }
  }

  toTimeStamp(time) {
    return +new Date(time.replace(/-/g, '/'))
  }

  async clickEvent(info?) {
    // 微页面组件内容点击埋点
    let ContentName, JumpContentID, JumpContentName
    if (this.data.showType === 'single') {
      ContentName = info.activity_name
      JumpContentID = info.coupon_id
      JumpContentName = info.activity_name
    } else {
      ContentName = `${this.data.coupBag.coupIds.length}张优惠券`
      this.bagCoupInfos.forEach(el => {
        JumpContentID = JumpContentID
          ? JumpContentID + '/' + el.coupon_id
          : el.coupon_id
        JumpContentName = JumpContentName
          ? JumpContentName + '/' + el.activity_name
          : el.activity_name
      })
    }

    await this.uploadEvent.sendRecord(
      'Click_MicroPages_Component',
      '',
      {
        PageName: document.title,
        ComponentName: this.data.title,
        ContentName,
        JumpType: '优惠券详情',
        JumpContentName,
        JumpContentID,
        isTabPage: +this.$route.query.isAppTab ? 'Y' : 'N',
      },
      [
        ['p1', 'PageName'],
        ['p2', 'ComponentName_ContentName'],
        ['p3', 'isTabPage'],
        ['p4', 'JumpType_JumpContentID_JumpContentName'],
      ]
    )
  }
}
